var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"hero-image",attrs:{"alt":"Banking hero image.","srcset":require("@/assets/hero-image-small.png") + " 220w, " + require("@/assets/hero-image-normal.png") + " 440w, " + require("@/assets/hero-image-large.png") + " 880w"}})
}
var staticRenderFns = []

export { render, staticRenderFns }